import _ from 'lodash'
import { InsuredInformationBreadcrumb } from 'quick-quote/components'
import RiderGroup from 'quick-quote/product-common/coverage-plan/components/rider/rider-group'
import TotalPremiumInput from 'quick-quote/product-common/coverage-plan/components/basic-plan/total-premium-input'
import PensionType from 'quick-quote/product-bumnan-ready/coverage-plan/components/pension-plan'
import PATH from 'quick-quote/constants/path'
import { Redirect } from 'react-router-dom'
import ModelFactorSelection from 'quick-quote/product-common/coverage-plan/components/basic-plan/model-factor-selection'
import BasicPlan from 'quick-quote/product-common/coverage-plan/components/basic-plan/basic-plan'
import KoomverRetireProductSelection from './koomver-retire-product-selection'
import BumnanSmartProductSelection from './bumnan-smart-product-selection'
import BumnanSmartPensionAgeSelection from './bumnan-smart-pension-age-selection'
import KoomverRetirePensionAgeSelection from './koomver-retire-pension-age-selection'

const renderProductPlanPaymentPeriodSelection = (code) => {
  switch (code) {
    case 'KOOMVER-RETIRE-1':
    case 'KOOMVER-RETIRE-2':
    case 'KOOMVER-RETIRE-3':
      return <KoomverRetireProductSelection />
    case 'R9506M1':
    case 'R9506M2':
    case 'R9506M3':
    case 'R9506M4':
    case 'R9555M':
    case 'R9560M':
    case 'R9565M':
    case 'R9570M':
      return <BumnanSmartProductSelection />
    default:
      return <BumnanReadyProductSelection />
  }
}

const renderPensionAgeSelection = (code) => {
  switch (code) {
    case 'R9506M1':
    case 'R9506M2':
    case 'R9506M3':
    case 'R9506M4':
    case 'R9555M':
    case 'R9560M':
    case 'R9565M':
    case 'R9570M':
      return <BumnanSmartPensionAgeSelection />
    case 'KOOMVER-RETIRE-1':
    case 'KOOMVER-RETIRE-2':
    case 'KOOMVER-RETIRE-3':
      return <KoomverRetirePensionAgeSelection />
    default:
      return null
  }
}

const CoveragePlan = ({
  toggleRider,
  riderCodes,
  pensionType,
  canProceedToCoveragePlan,
  displayProduct,
  editRiderSumAssured,
  editRiderSelectedPlan,
  editPensionType,
  infoMessage,
}) => {
  if (!canProceedToCoveragePlan) {
    return <Redirect to={PATH.PRODUCT_SELECTION} push />
  }
  return (
    <div>
      <InsuredInformationBreadcrumb />
      <div id="coverage-plan">
        <div className="content">
          <div id="basic-plan">
            <div className="content">
              <ModelFactorSelection />

              {renderProductPlanPaymentPeriodSelection(_.get(displayProduct, 'code'))}
              {renderPensionAgeSelection(_.get(displayProduct, 'code'))}

              <BasicPlan />
            </div>
          </div>
          <div id="total-premium">
            <TotalPremiumInput />
          </div>
          <div id="pension-select">
            <PensionType pensionType={pensionType} editPensionType={editPensionType} />
          </div>
          <RiderGroup
            riderCodes={riderCodes}
            toggleRider={toggleRider}
            editRiderSumAssured={editRiderSumAssured}
            editRiderSelectedPlan={editRiderSelectedPlan}
            infoMessage={infoMessage}
          />
        </div>
      </div>
    </div>
  )
}

export default CoveragePlan
